import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import StartOf = moment.unitOfTime.StartOf;
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { DateService } from '@shared/services/date.service';
import * as moment from 'moment';
@Injectable({
  providedIn: 'root'
})
export class SeriesGrouperService {
  private flagZoomSubject = new Subject<{ flagStart: number, flagEnd: number }>();
  flagZoom$ = this.flagZoomSubject.asObservable();


  public trInstant: (key: string | Array<string>, interpolateParams?: Object) => string | any;

  constructor(private translateService: TranslateService,private dateService:DateService) {
    this.trInstant = this.translateService.instant;
    this.trInstant = this.trInstant.bind(this.translateService);
  }

  /**
   * Calculate the tolerance (time unit) based on the range of the date difference in days.
   * @param diffInDays Number of days between the first and last data points.
   */
  public calculateTolerance(diffInDays: number): StartOf {
     if (diffInDays > moment.duration(2, 'months').asDays()) {
      return 'month';
    } else if (diffInDays > moment.duration(2, 'week').asDays()) {
      return 'week';
    } else if (diffInDays > moment.duration(1, 'day').asDays()) {
      return 'day';
    }
     return 'hour';
  }

  /**
   * Zooms in on a chart between two given x-axis values, with a buffer.
   * @param chart Highcharts chart instance.
   * @param flagStart Starting point of the flag.
   * @param flagEnd Ending point of the flag.
   */
  public zoomOnFlag(flagStart: number, flagEnd: number): void {
    const buffer = (flagEnd - flagStart) * 0.1; // Add 10% buffer on both sides
    this.flagZoomSubject.next({ flagStart: flagStart - buffer, flagEnd: flagEnd + buffer });
  }

  /**
   * Creates a grouped object based on the tolerance and the flags' series.
   * @param group Array of grouped items.
   * @param tolerance The tolerance level used for grouping (minute, day, month, year).
   * @param handleClick
   */
  public createGroupedObject(group: any[], tolerance: StartOf): any {
    if (group.length > 1) {
      const handleClick = () => {
        const flagStart = this.dateService.moment(group[0].x).valueOf();
        const flagEnd = this.dateService.moment(group[group.length - 1].x).valueOf();
        console.log(new Date(flagStart));
        console.log(new Date(flagEnd));
        this.zoomOnFlag(flagStart, flagEnd);
      };


      return {
        x: group[0].x,
        title: `${group[0].title || 'Grouped'} (${group.length})`,
        data: group,
        text: `${this.trInstant('website.equipment.detail.charts.period')} : ${this.getPeriod(group[0].x, tolerance)}</br>` +
          `${group[0].groupedDescription || ''}</br></br>
                <i>${this.trInstant('website.equipment.detail.charts.click_to_zoom')}</i>`,
        grouped: true,
        events: {
          click: handleClick
        },
      };
    } else {
      return group[0];
    }
  }

  private getPeriod(date: any, tolerance: string): string {
    const formats = {
      hour: ['DD/MM/YYYY HH:mm:ss', 'hour'],
      day: ['DD/MM/YYYY', 'day'],
      week: ['DD/MM/YYYY', 'week'],
      month: ['DD/MM/YYYY', 'month'],
      year: ['YYYY', 'year']
    };

    const [format, unit] = formats[tolerance];

    if (tolerance === 'hour' || tolerance === 'week' || tolerance === 'month') {
      const periodStart = this.dateService.moment(date).startOf(unit).format(format);
      const periodEnd = this.dateService.moment(date).endOf(unit).format(format);
      return `${periodStart} - ${periodEnd}`;
    }

    return this.dateService.moment(date).format(format);
  }
  /**
   * Group series data based on a tolerance level.
   * @param data Array of data to group.
   * @param tolerance Tolerance level for grouping.
   * @param chart Highcharts chart instance.
   */
  public groupByTolerance(data: any[], tolerance: StartOf): any[] {
    return _.chain(data)
      .groupBy(item => this.dateService.moment(item.x).startOf(tolerance).format()) // Group by tolerance
      .map(group => this.createGroupedObject(group, tolerance))
      .value();
  }

  /**
   * Main function to group series of any type based on a series identifier.
   * @param series Initial series data from the chart.
   * @param minDate
   * @param maxDate
   * @param chart Highcharts chart instance.
   * @param seriesId ID of the series to be grouped (optional for flexibility).
   */
  public groupSeries(series: any[], minDate: Date, maxDate: Date,  seriesId?: string[]): any[] {
    const diffInDays =  this.dateService.moment(maxDate).diff(this.dateService.moment(minDate), 'days');
    const tolerance = this.calculateTolerance(diffInDays);
    const clonedSeries = _.cloneDeep(series);

    clonedSeries?.forEach(itemSeries => {
      if (!seriesId || seriesId.includes(itemSeries.id)) {
        const data = itemSeries?.data || [];
        const groupedData = this.groupByTolerance(data, tolerance);

        itemSeries.data = groupedData;
        itemSeries.navigatorOptions.data = groupedData ;
      }
    });

    return clonedSeries;
  }
}
